import { createSlice } from "@reduxjs/toolkit";
import { generateMenuSelectionRequest } from "../thunks/menuSelectionThunks";
import { GenerateMenuSelectionRequestResponse } from "../../models/MenuSelection.model";

export interface MenuSelectionState {
  loading: boolean;
  error: string | null;
  success: boolean;
  response: GenerateMenuSelectionRequestResponse | null;
}

const initialState: MenuSelectionState = {
  loading: false,
  error: null,
  success: false,
  response: null,
};

const menuSelectionSlice = createSlice({
  name: "menuSelection",
  initialState,
  reducers: {
    clearMenuSelectionState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
      state.response = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(generateMenuSelectionRequest.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(generateMenuSelectionRequest.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.response = action.payload;
      })
      .addCase(generateMenuSelectionRequest.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
        state.success = false;
      });
  },
});

export const { clearMenuSelectionState } = menuSelectionSlice.actions;
export default menuSelectionSlice.reducer;